import { FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_CANCEL, scaleRCImageCompleteAction, singleRCFileUploadCompleteAction } from '../../actions';
import { call, put, race, select, take } from 'redux-saga/effects';
import { getEdsCreateRequestById, getFileInfoById } from '../../selectors';
import { singleRCFileUploadProgressSaga } from './singleRCFileUploadProgressSaga';
import { FileUploadStatus } from '../../enums';
import { compressImage, createEdsRequest, createMetadata, createMetadataRequest } from './uploadSingleFileSaga';
const edsUpload = function* (fileId, fileInfo, file) {
    const edsCreateRequest = yield select(getEdsCreateRequestById, fileId);
    const edsCreateResponse = yield call(createEdsRequest, edsCreateRequest);
    const { disableProgressNotification } = fileInfo;
    yield call(singleRCFileUploadProgressSaga, edsCreateResponse.documentUrl, fileId, file, disableProgressNotification);
    const fileMetadataRequest = createMetadataRequest(fileInfo, edsCreateResponse);
    const edsFileMetadataResponse = yield call(createMetadata, fileMetadataRequest);
    return edsFileMetadataResponse;
};
const uploadFile = function* (fileId) {
    const fileInfo = yield select(getFileInfoById, fileId);
    let file = fileInfo.file;
    if (fileInfo.maxImageSize) {
        if (!file.type.match(/binary\/octet-stream/)) {
            file = yield call(compressImage, fileInfo.file, fileInfo.maxImageSize);
        }
        yield put(scaleRCImageCompleteAction(fileInfo.id, true, file));
    }
    const edsFileMetadataResponse = yield edsUpload(fileId, fileInfo, file);
    yield put(singleRCFileUploadCompleteAction({
        docId: edsFileMetadataResponse.docId,
        docUID: edsFileMetadataResponse.docUID,
        uploadStatus: FileUploadStatus.SUCCESS,
        id: fileId
    }));
};
export const uploadRCSingleFileSaga = function* (action) {
    const fileInfo = yield select(getFileInfoById, action.payload.id);
    try {
        yield race({
            upload: call(uploadFile, fileInfo.id),
            cancel: take((cancelAction) => cancelAction.type === FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_CANCEL &&
                (cancelAction.payload.id === fileInfo.id || cancelAction.payload.id === fileInfo.parentId))
        });
    }
    catch (e) {
        yield put(singleRCFileUploadCompleteAction({ uploadStatus: FileUploadStatus.FAILED, id: action.payload.id }));
    }
};
//# sourceMappingURL=uploadRCSingleFileSaga.js.map